<template>
  <div class="page-container">
    <div class="page-header content-fade-in">
      <h1 class="title">智能问答</h1>
      <div class="subtitle">输入您的问题，AI将为您搜索相关答案</div>
    </div>
    <div class="content-container content-slide-up" style="animation-delay: 0.2s;">
      <div class="deep-seek" :class="{'initial-state': !loading && !answerList.length}">
        <div v-if="answerList.length" class="action-bar">
          <a-button 
            type="primary" 
            size="small"
            @click="handleBack"
            class="back-button"
          >
            <template #icon>
              <left-outlined />
            </template>返回
          </a-button>
        </div>
        
        <div v-if="loading && !answerList.length" class="loading-container content-fade-in">
          <a-spin :size="'large'" />
          <div class="loading-text">正在搜索中，请稍候...</div>
        </div>
        <div class="answer-container card-item" ref="answerContentRef" v-if="answerList.length" :class="{'fade-in': answerList.length}">
          <div class="answer-container-item" v-for="item in answerList" :key="item.id">
            <div class="answer-top">
              <div class="answer-top-content">
                <div class="answer-title-wrapper">
                  <h3>{{ item.title }}</h3>
                  <div>{{ item.time }}</div>
                </div>
              </div>
            </div>
            <div class="answer-content" style="padding: 20px">
              <div class="answer-content-title">
                会议相关资料：
              </div>
              <a-table v-if="item.answers.length" size="small" :columns="answerColumn" :data-source="item.answers" :pagination="false">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'action'">
                    <a-button type="primary" size="small" @click="goMeeting(record)">详情</a-button>
                  </template>
                </template>
              </a-table>
            </div>
            <div class="answer-footer">
              <div>会声智达:</div>
              <div class="answer-seek">
                <div v-if="item.loading" class="loading-indicator">
                  <a-spin />
                  <span style="margin-left: 10px">思考中...</span>
                </div>
                <div v-else v-html="item.lines?.map((line) => line.answer).join('')" class="html-content"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="search-title" v-if="!answerList.length && !loading">深度搜索</div>
        <div class="input-container">
          <a-input v-model:value="question" @pressEnter="startChat" :placeholder="answerList.length ? '继续提问...' : '请输入您的问题，例如：昨天上午的会议讨论了哪些事项？'" type="textarea" :rows="1" :auto-size="{ minRows: 1, maxRows: 3 }" :disabled="loading" />
          <a-button style="margin-left: 10px" type="primary" :loading="loading" :disabled="loading" @click="startChat">
            <template #icon v-if="!answerList.length && !loading">
              <SearchOutlined />
            </template>
            <span v-if="!loading">{{ answerList.length ? '发送' : '搜索' }}</span>
            <span v-else>处理中</span>
          </a-button>
        </div>
        <div v-if="!answerList.length && !loading" class="example-questions">
          <a-list bordered :dataSource="exampleQuestions">
            <template #header>
              <div>或者试试这些示例问题：</div>
            </template>
            <template #renderItem="{ item }">
              <a-list-item class="example-question-item" @click="handleExampleQuestionClick(item)">{{ item.label }}</a-list-item>
            </template>
          </a-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  nextTick,
  onMounted
} from 'vue'
import {
  useRouter
} from 'vue-router'
import {
  LeftOutlined,
  SearchOutlined
} from '@ant-design/icons-vue';
import axios from 'axios';
import {
  getFormattedDate
} from '@/utils/utils'
import {
  BASE_URL
} from '@/config/api';
// import { Bubble } from 'ant-design-x-vue';
// import { Spin } from 'ant-design-vue';
const router = useRouter()
const question = ref('')
const answerContentRef = ref()
const exampleQuestions = ref([{
    label: '昨天上午的会议讨论了哪些事项？',
  },
  {
    label: '帮我总结一下项目A的最新进展。'
  },
  {
    label: '上次关于预算的讨论结果是什么？'
  }
])
const answerColumn = [{
    title: '会议编号',
    dataIndex: 'meeting_no',
    key: 'meeting_no',
  },
  {
    title: '会议名称',
    dataIndex: 'meeting_name',
    key: 'meeting_name',
  },
  {
    title: '会议时间',
    dataIndex: 'meeting_time',
    key: 'meeting_time',
  },
  {
    title: '参会人',
    dataIndex: 'participants',
    key: 'participants',
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
  }
]
const isUserInteracting = ref(false)
onMounted(() => {
  if (answerContentRef.value) {
      answerContentRef.value.addEventListener('scroll', () => {
        isUserInteracting.value = true;
      });

    answerContentRef.value.addEventListener('click', () => {
      isUserInteracting.value = true;
    });

    setInterval(() => {
      isUserInteracting.value = false;
    }, 2000);
  }

  const route = router.currentRoute.value;
  if (route.query.question) {
    question.value = route.query.question;
    nextTick(() => {
      startChat();
    });
  }
})
const answerList = ref([])
const loading = ref(false)
const currentId = ref(crypto.randomUUID())
const goMeeting = (record) => {
  router.push({
    path: '/meetingedit/' + record.meeting_id
  })
}
const startChat = async () => {
  if (loading.value) return
  if (!question.value) return

  loading.value = true
  const uid = crypto.randomUUID()
  const keywrod = question.value
  question.value = ''
  try {
    await queryKnowledge(keywrod, uid)
    await queryChat(keywrod, uid)
  } catch(error) {
      console.error("Search failed:", error);
      const item = answerList.value.find(item => item.id == uid)
      if (item) {
          item.loading = false;
      }
  }
}

const queryKnowledge = async (keyword, uid) => {
  try {
    const response = await axios.get(`${BASE_URL}/konwledge_search`, {
      params: {
        keyword
      },
    })
    if (response && response.data) {
      answerList.value.push({
        id: uid,
        title: keyword,
        time: getFormattedDate(),
        answers: response.data,
        loading: true,
        lines: []
      })
      await nextTick()
      if (answerContentRef.value) {
        const itemElements = answerContentRef.value.querySelectorAll('.answer-container-item');
        if (itemElements.length > 0) {
            const lastItemElement = itemElements[itemElements.length - 1];
            const footerElement = lastItemElement.querySelector('.answer-footer');
            if (footerElement) {
                 footerElement.scrollIntoView({ behavior: "smooth", block: "end" });
            }
        }
      }

    } else {
       answerList.value.push({
        id: uid,
        title: keyword,
        time: getFormattedDate(),
        answers: [],
        loading: true,
        lines: []
      })
       console.warn("Knowledge search returned no results for:", keyword);
    }
  } catch (error) {
      console.error('Error fetching knowledge:', error);
       answerList.value.push({
        id: uid,
        title: `搜索知识库失败: ${keyword}`,
        time: getFormattedDate(),
        answers: [],
        loading: true,
        lines: []
      });
      throw error;
  }
}

const queryChat = async (keyword, uid) => {
  const item = answerList.value.find(item => item.id == uid)
  if (!item) {
    console.error("Cannot find item to update for chat:", uid);
    loading.value = false;
    return;
  }
  const params = {
    query: keyword,
    user: currentId.value
  }

  try {
    const response = await fetch(`${BASE_URL}/chat-messages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream'
      },
      body: JSON.stringify(params)
    });

    if (!response.ok) {
        throw new Error(`SSE request failed with status ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const {
        done,
        value
      } = await reader.read();

      if (done) {
        console.log('Stream complete');
        item.loading = false;
        loading.value = false;
        break;
      }

      const chunk = decoder.decode(value, {
        stream: true
      });
      const lines = chunk.split('\n');

      lines.forEach(line => {
        if (line.startsWith('data:')) {
          item.loading = false
          const data = line.replace('data:', '').trim();
          try {
              const parsedData = JSON.parse(data);
              parsedData.htmlProcessed = true;
              item.lines = [...(item.lines || []), parsedData];

              nextTick(() => {
                   if (!isUserInteracting.value && answerContentRef.value) {
                        const itemElements = answerContentRef.value.querySelectorAll('.answer-container-item');
                        if (itemElements.length > 0) {
                            const lastItemElement = itemElements[itemElements.length - 1];
                            const footerElement = lastItemElement.querySelector('.answer-footer');
                            if (footerElement) {
                                footerElement.scrollIntoView({ behavior: "smooth", block: "end" });
                            }
                        }
                   }
               });

          } catch (parseError) {
              console.error('Error parsing SSE data:', parseError, 'Raw data:', data);
          }
        }
      });
    }
  } catch (error) {
    console.error('Error fetching SSE stream:', error);
    if (item) {
      item.loading = false;
      item.lines = [...(item.lines || []), { answer: `<p style="color: red;">抱歉，回答生成失败，请稍后重试。</p>` }];
    }
    loading.value = false;
     throw error;
  } finally {
     if (item) item.loading = false;
     loading.value = false;
  }
}

const handleExampleQuestionClick = (item) => {
  question.value = item.label
  startChat()
}

const handleBack = () => {
  answerList.value = [];
  question.value = '';
  loading.value = false;
  currentId.value = crypto.randomUUID();
}
</script>

<style scoped lang="less">
.page-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
}



.content-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  padding: 0;
  position: relative;
}

.deep-seek {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  position: relative;

  .search-title {
    display: none;
  }
  .example-questions {
    display: none;
  }
  .action-bar {
    position: relative;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    z-index: 30;
  }
  .answer-container {
    flex: 1;
    min-height: 100px;
    overflow-y: auto;
    margin-bottom: 16px;
    padding: 20px;
    padding-top: 20px;
    background-color: #f9fafb;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    position: relative;
  }
  .input-container {
    width: 100%;
    flex-shrink: 0;
  }
}

.deep-seek.initial-state {
  justify-content: center;
  align-items: center;
  text-align: center;

  .search-title {
    display: block;
    font-size: 28px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 30px;
    animation: fadeIn 0.5s ease;
  }

  .input-container {
    max-width: 650px;
    width: 100%;
    margin-bottom: 30px;
    animation: fadeIn 0.5s ease 0.1s;
    animation-fill-mode: backwards;
    :deep(.ant-input-textarea textarea) {
      height: 50px !important;
      padding-top: 14px;
      padding-bottom: 14px;
      font-size: 16px;
    }
    :deep(.ant-btn) {
      height: 50px;
      font-size: 16px;
    }
  }

  .example-questions {
    display: block;
    max-width: 650px;
    width: 100%;
    margin-top: 0;
    text-align: left;
    animation: fadeIn 0.5s ease 0.2s;
    animation-fill-mode: backwards;
    :deep(.ant-list-header) {
      font-weight: 500;
      color: #4b5563;
    }
  }

  .answer-container {
    display: none;
  }
  .back-button {
    display: none;
  }
}

.back-button {
  display: inline-flex !important;
  align-items: center !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045) !important;
  
  &:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15) !important;
  }
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 50px 0;
  transition: opacity 0.3s ease;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
}

.loading-text {
  margin-top: 15px;
  color: #4b5563;
  font-size: 14px;
}

.input-container {
  display: flex;
  align-items: flex-end;
  transition: all 0.3s ease;
  :deep(.ant-input-textarea) {
    flex: 1;
  }
  :deep(.ant-input-textarea textarea) {
    line-height: 1.5;
  }
  :deep(.ant-btn) {
    white-space: nowrap;
  }
}

.example-questions {
  :deep(.ant-list-bordered) {
    border-radius: 6px;
    border-color: #e5e7eb;
  }
  :deep(.ant-list-header) {
    padding: 8px 16px;
    background-color: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    font-size: 13px;
  }
  :deep(.ant-list-item) {
    padding: 10px 16px;
    font-size: 14px;
    &:last-child {
      border-bottom: none !important;
    }
  }
}
.example-question-item {
  cursor: pointer;
  transition: background-color 0.2s;
  color: #3b82f6;
}
.example-question-item:hover {
  background-color: #eff6ff;
}

.answer-container-item {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  animation: slideIn 0.4s ease-out;
  &:last-child {
    margin-bottom: 0;
  }
}
.answer-top {
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
  &-content {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }
}
.answer-title-wrapper {
  flex: 1;
  h3 {
    margin-top: 0;
    margin-bottom: 4px;
    font-size: 16px;
    color: #111827;
  }
  div {
    font-size: 12px;
    color: #6b7280;
  }
}
.answer-content {
  padding: 20px;
  &-title {
    margin-bottom: 12px;
    font-weight: 500;
    color: #374151;
  }
  :deep(.ant-table-small) {
    border: 1px solid #e5e7eb;
    border-radius: 4px;
  }
}
.answer-footer {
  padding: 16px 20px;
  border-top: 1px solid #f3f4f6;
  background-color: #f9fafb;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  div:first-child {
    font-weight: 500;
    color: #374151;
    margin-bottom: 8px;
  }
}
.answer-seek {
  .loading-indicator {
    display: flex;
    align-items: center;
    padding: 10px 0;
    color: #6b7280;
  }
  .html-content {
    background-color: transparent;
    border-radius: 4px;
    padding: 0;
    line-height: 1.6;
    color: #374151;
    :deep(p) {
      margin-bottom: 0.8em;
      &:last-child {
        margin-bottom: 0;
      }
    }
    :deep(details) {
      margin-bottom: 10px;
    }
    :deep(summary) {
      cursor: pointer;
      font-weight: 500;
      color: #1f2937;
    }
    :deep(ul),
    :deep(ol) {
      padding-left: 20px;
      margin-bottom: 0.8em;
    }
    :deep(li) {
      margin-bottom: 0.4em;
    }
    :deep(code) {
      background-color: #f3f4f6;
      padding: 2px 4px;
      border-radius: 3px;
      font-size: 0.9em;
    }
    :deep(pre) {
      background-color: #f3f4f6;
      padding: 10px;
      border-radius: 4px;
      overflow-x: auto;
    }
    :deep(pre) code {
      background-color: transparent;
      padding: 0;
      border-radius: 0;
      font-size: 1em;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideIn {
  from {
    transform: translateY(15px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.content-slide-up {
  animation: contentSlideUp 0.5s ease-out forwards;
  opacity: 0;
}
@keyframes contentSlideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.content-fade-in {
  animation: fadeIn 0.5s ease forwards;
  opacity: 0;
}

</style>
